




















import { Component, Vue, Prop } from 'vue-property-decorator'
import BoxTitle from './BoxTitle.vue'

@Component({
  components: {
    BoxTitle
  }
})

export default class AppCase extends Vue {
  @Prop()
  cases!: Array<object>
}

